import { Link as RouterLink } from 'react-router-dom';
// @mui
import { Box, Link, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
// hooks
import useAuth from '../../../hooks/useAuth';
// routes
import { PATH_LMS } from '../../../routes/paths';
// components
import MyAvatar from '../../../components/MyAvatar';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(2, 2.5),
  borderRadius: Number(theme.shape.borderRadius) * 1.5,
  backgroundColor: theme.palette.grey[500_12],
  transition: theme.transitions.create('opacity', {
    duration: theme.transitions.duration.shorter,
  }),
}));

// ----------------------------------------------------------------------

type Props = {
  isCollapse: boolean | undefined;
};

export default function NavbarAccount({ isCollapse }: Props) {
  const { user } = useAuth();

  return (
    <Link underline="none" color="inherit" component={RouterLink} to={PATH_LMS.personal.profile}>
      <RootStyle
        sx={{
          ...(isCollapse && {
            bgcolor: 'transparent'
          }),
        }}
      >
        <MyAvatar />

        <Box
          sx={{
            ml: 2,
            transition: (theme) =>
              theme.transitions.create('width', {
                duration: theme.transitions.duration.shorter,
              }),
            ...(isCollapse && {
              ml: 0,
              width: 0
            }),
          }}
          style={{overflow: 'hidden'}}
        >
          <Typography variant="subtitle2" noWrap>
            {user?.userName}
          </Typography>
          <Typography
            variant="body2"
            sx={{ color: 'text.secondary' }}
            noWrap={isCollapse ? true : false}
          >
            {user?.role}
          </Typography>
        </Box>
      </RootStyle>
    </Link>
  );
}
